/** 退出接口会重定向；必须使用页面导航，让服务端处理 HttpOnly 和跨域 Cookie。 */
export function getLogoutUrl(redirectUrl = window.location.href) {
    const isDevelopment = process.env.NODE_ENV === 'development';
    const url = new URL(
        isDevelopment ? '/__auth/logout' : '/api/v3/users/vivo/logout',
        isDevelopment ? window.location.origin : (process.env.REACT_APP_API_BASE || window.location.origin),
    );
    url.searchParams.set('redirect_uri', redirectUrl);
    return isDevelopment ? `${url.pathname}${url.search}` : url.href;
}
